export default {
  'ar': 'العربية',
  'hy': 'Հայերեն',
  'bs': 'Bosanski',
  'bg': 'Български',
  'hr': 'Hrvatski',
  'da': 'Dansk',
  'nl': 'Nederlands',
  'en': 'English',
  'et': 'Eesti',
  'es': 'Español',
  'tl': 'Filipino',
  'fi': 'Suomi',
  'fr': 'Français',
  'ka': 'ქართული',
  'de': 'Deutsch',
  'el': 'Ελληνικά',
  'hu': 'Magyar',
  'id': 'Bahasa Indonesia',
  'it': 'Italiano',
  'lv': 'Latviešu',
  'lt': 'Lietuvių',
  'mk': 'Македонски',
  'mt': 'Malti',
  'no': 'Norsk',
  'pl': 'Polski',
  'pt': 'Português',
  'ro': 'Română',
  'ru': 'Русский',
  'sr': 'Српски',
  'sk': 'Slovenčina',
  'sl': 'Slovenščina',
  'sw': 'Kiswahili',
  'sv': 'Svenska',
  'th': 'ไทย',
  'tr': 'Türkçe',
  'vi': 'Tiếng Việt',
  'cs': 'Čeština',
  'ga': 'Gaeilge',
  'lb': 'Lëtzebuergesch'
}
  